import Reveal from './Reveal';
import { identityPoints } from '@/mocks/home';

export default function IdentitySection() {
  return (
    <section id="identity" className="py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
            <div>
              <span className="text-xs tracking-[0.3em] text-secondary-700 uppercase">Identity / 真实身份</span>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">关于「她到底是谁」</h2>
            </div>
            <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
              这大概是围绕她讨论最多、也最难有定论的问题。下面是几个需要先厘清的要点。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {identityPoints.map((point, idx) => (
            <Reveal key={point.title} delay={idx * 80}>
              <article className="h-full p-6 rounded-lg border border-background-200 bg-background-100">
                <span className="text-sm font-heading font-bold text-accent-600">0{idx + 1}</span>
                <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950 mb-3">{point.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{point.text}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-4 rounded-lg border border-accent-300 bg-accent-100/70 px-5 py-4">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 shrink-0">
              <i className="ri-alert-line text-lg"></i>
            </span>
            <p className="text-sm text-accent-900 leading-relaxed">
              提醒：网络上关于其真实身份的“独家爆料”大多无法查证，请勿仅凭单一来源下结论，更不要传播未经核实的信息。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}